import { BooleanInput, SelectInput, SimpleForm, required } from "react-admin";
import {
  DebouncedDateInput,
  DebouncedTextInput,
  ReferenceCheckboxGroupInput,
  Toolbar,
  useSaveMutation,
} from "ra-friendsofbabba";

import LogsField from "./fields/LogsField";
import { NotifyResearcherButton } from "../component/button";
import React from "react";
import UserLogsField from "./fields/UserLogsField";

const STATUSES = ["active", "inactive", "deleted"].map((id) => ({
  id,
  name: id,
}));

const Form = ({ create = false, permissions, ...props }) => {
  const save = useSaveMutation({ ...props });
  return (
    <SimpleForm
      {...props}
      save={save}
      toolbar={
        <Toolbar>
          <NotifyResearcherButton />
        </Toolbar>
      }
    >
      <SelectInput source="status" validate={required()} choices={STATUSES} />
      <DebouncedTextInput source="username" validate={required()} />
      <DebouncedTextInput source="password" type="password" />
      <DebouncedTextInput source="email" validate={required()} />
      <DebouncedTextInput source="profile.name" validate={required()} />
      <DebouncedTextInput source="profile.surname" validate={required()} />
      <DebouncedTextInput source="profile.fiscal_code" maxLength={16} />
      <DebouncedTextInput source="profile.spid_code" maxLength={50} />
      <DebouncedTextInput source="profile.birth_place" />
      <DebouncedDateInput source="profile.birth_date" />
      <DebouncedDateInput source="profile.hiring_date" />
      <DebouncedTextInput source="profile.phone" maxLength={30} />
      <BooleanInput source="allow_local_login" fullWidth />
      <ReferenceCheckboxGroupInput
        reference="roles"
        source="roles"
        validate={required()}
        fullWidth
      />
      <LogsField fullWidth />
      <UserLogsField fullWidth />
    </SimpleForm>
  );
};
export default Form;
